<ol class="breadcrumb breadcrumb-line text-muted fs-6 fw-semibold">
    <li *ngFor="let item of list; let isLast = last" class="breadcrumb-item" [ngClass]="{ 'text-muted': isLast }">
        <a *ngIf="!isLast; else lastItem" [routerLink]="item.link" class="">
            {{ item.label | translate }}
        </a>
        <ng-template #lastItem>{{ item.label | translate }}</ng-template>
    </li>
</ol>